import { render, staticRenderFns } from "./Sensor.vue?vue&type=template&id=50c0ff2f&scoped=true&"
import script from "./Sensor.vue?vue&type=script&lang=js&"
export * from "./Sensor.vue?vue&type=script&lang=js&"
import style0 from "./Sensor.vue?vue&type=style&index=0&id=50c0ff2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c0ff2f",
  null
  
)

export default component.exports